'use client';

import { useEffect, useState } from 'react';

type ReturnType = [number, number];

export const useDomMeasure = (
  ref: React.MutableRefObject<HTMLElement | null>,
  triggers: Array<any> = []
): ReturnType => {
  const [domRect, setDomRect] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (ref.current) {
      const elemDomRect = ref.current.getBoundingClientRect();
      setDomRect(elemDomRect);
    }
  }, [ref.current, ...triggers]);

  useEffect(() => {
    if (ref.current) {
      const setRectCallback = () => {
        if (!ref.current) return;
        const elemDomRect = ref.current.getBoundingClientRect();
        const { width: newWidth, height: newHeight } = elemDomRect;
        if (newWidth !== domRect.width || newHeight !== domRect.height) {
          setDomRect(elemDomRect);
        }
      };
      window.addEventListener('resize', setRectCallback);
      return () => window.removeEventListener('resize', setRectCallback);
    }
    return () => null;
  }, []);

  return [domRect.width, domRect.height];
};
